export const HOME_SECTION_NAVIGATION_EVENT =
  'dotpolyline:home-section-navigation';

export const HOME_SECTION_NAVIGATION_DELAY = 240;
